import defaultLocale from "../../locale/en-US/index.js";
export default defaultLocale;import defaultLocale from "../../locale/en-US/index.js";
export default defaultLocale;